/**
 * Canonical email form used for ALL identity and quota keys across the platform.
 *
 * Cognito's user pool is case-sensitive (immutable setting), so the application
 * layer must guarantee that every email reaching Cognito, Postgres, or Resend
 * is already in canonical form: trimmed + lowercased. The database enforces the
 * same invariant with CHECK (email = lower(btrim(email))).
 *
 * Deliberately NOT normalized: gmail dots / plus tags — only gmail folds dots,
 * every other major provider treats them as significant.
 */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** Basic format check shared by frontend and backend validation paths. */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmailFormat(email: string): boolean {
  return EMAIL_REGEX.test(email);
}
